import { useState } from 'react';
import { useLocation } from 'react-router';
import { ReferralAlreadyRecordedDialog } from '~/components/ReferralAlreadyRecordedDialog';
import { ReferralNotEligibleDialog } from '~/components/ReferralNotEligibleDialog';

/** The navigation state `ReferralLinkRedirect` lands a signed-in office with. */
export interface IReferralLinkLocationState {
  /** A v2 referral tap from an office that already has an account (GOTU-7434). */
  showReferralNotEligible?: boolean;
  /** Set instead for a re-tap of the code this office signed up with (GOTU-9922). */
  showReferralAlreadyRecorded?: boolean;
}

/**
 * The dialogs for a signed-in office opening a v2 referral link, read off the
 * navigation state `ReferralLinkRedirect` sets. Rendered wherever that redirect
 * lands an office with an account: the dashboard, and the sign-up wizard for
 * an office that has not finished it yet.
 *
 * Not the Account Exists dialog: this office is already logged in, so its "log
 * in to your existing account" copy would be nonsense here. That one belongs to
 * the signed-out sign-up failure, and `SignUpForm` renders it there.
 */
export const ReferralLinkDialogs = () => {
  const { state } = useLocation();
  const { showReferralNotEligible, showReferralAlreadyRecorded } =
    (state as IReferralLinkLocationState | null) || {};
  // Latched into state so closing a dialog dismisses it for good: the
  // navigation state survives a re-render, so reading it directly would
  // re-open the dialog on the next one.
  const [isNotEligibleOpen, setIsNotEligibleOpen] = useState(Boolean(showReferralNotEligible));
  const [isAlreadyRecordedOpen, setIsAlreadyRecordedOpen] = useState(
    Boolean(showReferralAlreadyRecorded),
  );

  return (
    <>
      <ReferralNotEligibleDialog
        open={isNotEligibleOpen}
        onClose={() => setIsNotEligibleOpen(false)}
      />
      <ReferralAlreadyRecordedDialog
        open={isAlreadyRecordedOpen}
        onClose={() => setIsAlreadyRecordedOpen(false)}
      />
    </>
  );
};
